// Sidebar stays mounted throughout all pages, instead of being loaded per-page
import React, { useState, useCallback } from "react";
import { Outlet } from "react-router-dom";
import SideBar from "./components/SideBar/SideBar";

const Layout = () => {
  // This callback will be called by NotificationButton
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerPlayerRefresh = useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
  }, []);

  return (
    <div style = {{display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <SideBar onPlayerRefresh={triggerPlayerRefresh} />

      <div style = {{ flex: 1, overflowY: "auto" }}>
        {/* Current page */}
        <Outlet context={{ refreshTrigger }} /> 
      </div>
    </div>
  );
};

export default Layout;
